export const CancelOneTimePayment = 'Cancel One-time Payment'
export const OneTimePaymentSuccessfullyCanceled = '✅ One-time Payment successfully canceled'
export const OneTimePaymentSuccessfullyCanceledOk = 'OK'

export const AutoPayOff = 'Auto-pay off'
export const CancelAutoPay = 'Cancel Auto-pay'

export const AutoPayScheduledFor = 'Auto-pay scheduled for'
